import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "59 29 83 84"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1A9999",
      d: "M64.774 54.569v52.805h52.072c10.726 0 19.416-8.813 19.416-19.69V34.88H84.19c-10.726 0-19.416 8.813-19.416 19.69m51.823 46.188c-7.16 0-12.96-5.882-12.96-13.143s5.8-13.144 12.96-13.144 12.961 5.882 12.961 13.144c0 7.261-5.8 13.143-12.961 13.143m13.031-59.21v26.427h-26.061c0-14.594 11.67-26.428 26.061-26.428m-32.228 0v59.22H71.26V54.78c0-7.312 5.84-13.234 13.05-13.234z"
    }, null, -1)
  ])))
}
export default { render: render }